import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export const WalletAssetSelectionIllustration = (
  props: SVGProps,
): JSX.Element => {
  const { title = 'WalletAssetSelection', className, ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cn('fill-current', className)}
      viewBox="0 0 168 178"
      fill="none"
      {...restProps}
    >
      <title>{title}</title>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="168"
        height="178"
        viewBox="0 0 168 178"
        fill="none"
      >
        <g clipPath="url(#clip0_1814_47299)">
          <path
            d="M30.864 8.45802C33.2094 8.45802 35.1108 6.56463 35.1108 4.22901C35.1108 1.89339 33.2094 0 30.864 0C28.5185 0 26.6172 1.89339 26.6172 4.22901C26.6172 6.56463 28.5185 8.45802 30.864 8.45802Z"
            fill="#5580F6"
          />
          <path
            d="M75.9031 8.45802C78.2485 8.45802 80.1499 6.56463 80.1499 4.22901C80.1499 1.89339 78.2485 0 75.9031 0C73.5576 0 71.6562 1.89339 71.6562 4.22901C71.6562 6.56463 73.5576 8.45802 75.9031 8.45802Z"
            fill="#5580F6"
          />
          <path
            d="M134.989 8.45802C137.334 8.45802 139.236 6.56463 139.236 4.22901C139.236 1.89339 137.334 0 134.989 0C132.644 0 130.742 1.89339 130.742 4.22901C130.742 6.56463 132.644 8.45802 134.989 8.45802Z"
            fill="#5580F6"
          />
          <path
            d="M123.551 0.232481L119.523 4.24341L123.551 8.25434L127.579 4.24341L123.551 0.232481Z"
            fill="white"
          />
          <path
            d="M2.78906 98.7148V89.0197C2.78906 89.0197 3.43225 77.697 16.9745 77.697H93.3245V98.7192"
            fill="black"
          />
          <path
            d="M2.78906 98.7148V89.0197C2.78906 89.0197 3.43225 77.697 16.9745 77.697H93.3245V98.7192"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M93.3229 98.7148L7.76562 101.185"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M57.1859 125.277L88.7422 31.1421L44.991 16.5983L13.4347 110.733L57.1859 125.277Z"
            fill="black"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M47.107 70.6999C47.107 57.7452 36.5648 47.2429 23.5557 47.2429C10.5465 47.2429 0 57.7452 0 70.6999C0 83.6501 10.5465 94.1524 23.5513 94.1524C36.556 94.1524 47.1026 83.6501 47.1026 70.6999H47.107Z"
            fill="#5580F6"
          />
          <path
            d="M23.412 66.4317L28.2939 71.2932L23.412 76.1547L18.5301 71.2932L23.412 66.4317Z"
            stroke="black"
            strokeWidth="1.09"
          />
          <path
            d="M14.2793 62.197L32.5742 62.197L32.5742 80.4109L14.2793 80.4109L14.2793 62.197Z"
            stroke="black"
            strokeWidth="1.09"
          />
          <path
            d="M23.5595 89.375C13.198 89.375 4.79688 81.0135 4.79688 70.6954C4.79688 60.3774 13.198 52.0159 23.5595 52.0159C33.9166 52.0159 42.3177 60.3774 42.3177 70.6954C42.3177 81.0135 33.9166 89.375 23.5595 89.375Z"
            stroke="black"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M48.2164 137.063L127.281 76.6484L99.2024 40.2087L20.1376 100.623L48.2164 137.063Z"
            fill="black"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M48.2164 137.063L127.281 76.6484L99.2024 40.2087L20.1376 100.623L48.2164 137.063Z"
            fill="black"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M50.7422 106.107L62.3945 73.9989L96.554 71.1035L84.9061 103.216L50.7422 106.107Z"
            fill="black"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M38.4141 124.343C45.52 118.912 55.181 120.496 60.6393 127.576L38.4141 124.343Z"
            fill="black"
          />
          <path
            d="M38.4141 124.343C45.52 118.912 55.181 120.496 60.6393 127.576"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M32.4135 90.9453C37.8674 98.0214 36.9731 107.817 29.8672 113.249L32.4135 90.9453Z"
            fill="black"
          />
          <path
            d="M32.4135 90.9453C37.8674 98.0214 36.9731 107.817 29.8672 113.249"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M108.929 52.8405C101.823 58.2715 92.052 56.622 86.5938 49.5415L108.929 52.8405Z"
            fill="black"
          />
          <path
            d="M108.929 52.8405C101.823 58.2715 92.052 56.622 86.5938 49.5415"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M114.817 86.1724C109.363 79.0963 110.368 69.3617 117.478 63.9307L114.817 86.1724Z"
            fill="black"
          />
          <path
            d="M114.817 86.1724C109.363 79.0963 110.368 69.3617 117.478 63.9307"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M76.692 115.293L48.5547 78.7805"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M98.7936 98.4077L70.6562 61.8909"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M91.0557 43.8256C91.0557 30.871 80.5136 20.3687 67.5044 20.3687C54.4997 20.3687 43.9531 30.871 43.9531 43.8256C43.9531 56.7759 54.4997 67.2782 67.5044 67.2782C80.5136 67.2782 91.0557 56.7759 91.0557 43.8256Z"
            fill="#5580F6"
          />
          <path
            d="M74.9111 49.8464H59.9727L67.4414 38.5125L74.9111 49.8464Z"
            stroke="black"
            strokeWidth="1.09"
          />
          <path
            d="M67.2157 62.8164C56.8542 62.8164 48.4531 54.4549 48.4531 44.1369C48.4531 33.8188 56.8542 25.4573 67.2157 25.4573C77.5728 25.4573 85.9739 33.8188 85.9739 44.1369C85.9739 54.4549 77.5728 62.8164 67.2157 62.8164Z"
            stroke="black"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M104.573 178H16.0291C15.7252 178 15.4256 177.996 15.1304 177.982C7.65007 177.667 1.84375 171.336 1.84375 163.883V90.5112C1.84375 90.5112 5.97161 98.7148 16.038 98.7148H104.573V178.004V178Z"
            fill="white"
          />
          <path
            d="M85.6978 129.56H104.575V146.155H85.6978C81.0986 146.155 77.3672 142.435 77.3672 137.86C77.3672 133.28 81.103 129.564 85.6978 129.564V129.56Z"
            fill="#5580F6"
          />
          <path
            d="M1.84375 137.859H55.6998"
            stroke="black"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M55.6296 139.342C56.452 139.342 57.1187 138.678 57.1187 137.859C57.1187 137.041 56.452 136.377 55.6296 136.377C54.8073 136.377 54.1406 137.041 54.1406 137.859C54.1406 138.678 54.8073 139.342 55.6296 139.342Z"
            fill="black"
          />
          <path
            d="M1.84375 148.656H39.7831V167.432"
            stroke="black"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M38.2969 167.357C38.2969 168.178 38.9665 168.84 39.7859 168.84C40.6053 168.84 41.2749 168.173 41.2749 167.357C41.2749 166.541 40.6053 165.875 39.7859 165.875C38.9665 165.875 38.2969 166.541 38.2969 167.357Z"
            fill="black"
          />
          <path
            d="M1.84375 127.059H39.7831V108.283"
            stroke="black"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M41.2749 108.357C41.2749 107.537 40.6053 106.875 39.7859 106.875C38.9665 106.875 38.2969 107.541 38.2969 108.357C38.2969 109.173 38.9665 109.84 39.7859 109.84C40.6053 109.84 41.2749 109.173 41.2749 108.357Z"
            fill="black"
          />
          <path
            d="M74.0147 95.0736C78.2944 95.0736 81.7638 91.6188 81.7638 87.357C81.7638 83.0952 78.2944 79.6404 74.0147 79.6404C69.735 79.6404 66.2656 83.0952 66.2656 87.357C66.2656 91.6188 69.735 95.0736 74.0147 95.0736Z"
            fill="white"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M159.318 150.389C163.873 150.389 167.561 146.712 167.561 142.181C167.561 137.649 163.873 133.973 159.318 133.973H127.657C123.106 133.973 119.414 137.649 119.414 142.181C119.414 146.712 123.106 150.389 127.657 150.389H159.318Z"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M151.812 144.729L155.275 139.627L158.738 144.729H151.812Z"
            fill="#5580F6"
          />
          <path
            d="M146.814 144.124H130.148"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M146.814 140.233H130.148"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M159.318 125.545C163.873 125.545 167.561 121.869 167.561 117.337C167.561 112.806 163.873 109.129 159.318 109.129H127.657C123.106 109.129 119.414 112.806 119.414 117.337C119.414 121.869 123.106 125.545 127.657 125.545H159.318Z"
            stroke="#5580F6"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M151.812 119.891L155.275 114.784L158.738 119.891H151.812Z"
            fill="#5580F6"
          />
          <path
            d="M146.814 119.281H130.148"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
          <path
            d="M146.814 115.394H130.148"
            stroke="white"
            strokeWidth="1.09083"
            strokeMiterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_1814_47299">
            <rect width="168" height="178" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </svg>
  );
};
